module.exports = __webpack_public_path__ + "static/fonts/materialdesignicons-webfont.3e2c1c7.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fonts/materialdesignicons-webfont.eot?v=5.1.45
// module id = 0x9H
// module chunks = 1